import React, { useContext, useEffect } from "react";
import { useLocation, Navigate } from "react-router-dom";
// // import Hero from "../DashBoardComponents/Hero";
// import Providers from "../DashBoardComponents/Providers";
// import Patients from "../DashBoardComponents/Patients";
// import Clinic from "../DashBoardComponents/Clinic";
// import FAQ from "../DashBoardComponents/FAQ";
// import Contact from "../DashBoardComponents/Contact";
// import Layout from "../Layout";
// import Footer from "../DashBoardComponents/Footer";
// import Query from "../DashBoardComponents/Query";
import { APP_ROUTES } from "../PageRouting/pageRoutes";
import Navbar from "../DashBoardComponents/Navbar";
import { Features } from "../DoxzonNew/Features";
import DashboardPreview  from "../DoxzonNew/DashboardPreview";
// import { Testimonials } from "../DoxzonNew/Testmonials";
import { Hero } from "../DoxzonNew/Hero";
import { FAQ } from "../DoxzonNew/FAQ";
import { Contact } from "../DoxzonNew/Contact";
import { Footer } from "../DoxzonNew/Footer";
import { AIConsultation } from "../DoxzonNew/AIConsultation";
import { ProvidersPatients } from "../DoxzonNew/ProvidersPatients";
import ServiceCards from "../DoxzonNew/Servicecards";
import MembershipSlider from "../DashBoardComponents/MembershipSlider";
import AbhaFeatureSection from "../DoxzonNew/Abhafeaturesection.";


function HomePage() {
  const location = useLocation();
  const loggedUserJson = localStorage.getItem("patientData");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  if (loggedUser) {
    return <Navigate to={APP_ROUTES.HOME} replace />;
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <MembershipSlider />
      <main>
        <Hero />

        <div id="patients-section">
          <Features />
        </div>
        <AIConsultation />
        <div id="providers-section">
          <ProvidersPatients />
        </div>
        <ServiceCards />
        <div id="clinic-section">
        
        <DashboardPreview />
        </div>
        {/* <Testimonials /> */}
        <FAQ />
        <Contact />
        <AbhaFeatureSection />
        <Footer />
    
      </main>
    </div>
  );
}

export default HomePage;
